import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Img = styled.img`
  height: auto;
  width: auto;
  max-width: 100%;
  max-height: ${({ isHandheld }) => (isHandheld ? '60vh' : '80vh')};
  margin-top: ${({ isHandheld }) => (isHandheld ? '' : '2.5vh')};
`;

const FullscreenImg = styled.img`
  max-width: ${({ isHandheld, desktopMaxWidth }) => (isHandheld ? '100vw' : desktopMaxWidth)};
  max-height: ${({ isHandheld, isLandscape }) => (isHandheld && isLandscape ? '100vh' : '')};
`;

const ImgWrapper = styled.div`
  text-align: center;
  vertical-align: middle;
`;

const FullscreenImgWrapper = styled.div`
  max-height: 100vh;
`;

const CustomContainer = ({ data, isModal, isFullscreen }) => {
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });
  const isLandscape = useMediaQuery({ query: '(orientation: landscape)' });
  const renderModalImg = isModal && !isFullscreen;
  const Wrapper = renderModalImg ? ImgWrapper : FullscreenImgWrapper;
  const DisplayImg = renderModalImg ? Img : FullscreenImg;

  return (
    <Wrapper>
      <DisplayImg
        alt={data.title}
        src={data.src}
        isHandheld={isTabletOrMobile}
        isLandscape={isLandscape}
        desktopMaxWidth={`${data.width > data.height ? '91%' : 'auto'}`}
      />
    </Wrapper>
  );
};

CustomContainer.propTypes = {
  data: PropTypes.shape({
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  isModal: PropTypes.bool.isRequired,
  isFullscreen: PropTypes.bool.isRequired,
};

export default CustomContainer;
